export const APP_NAME = 'basket-provider';
export const PACKAGE_NAME = '@ori/basket-provider';
export const CONFIG_ELEMENT_ID = `${APP_NAME}-data`;
export const ROOT_ELEMENT_ID = `${APP_NAME}-root`;

/** Storage key under which the shopping context data gets stored. */
export const CONTEXT_KEY = 'shoppingContext';

/** Local storage data will be cleaned on next reload when older than this timeout (currently 5 minutes in ms). */
export const DATA_CACHE_TIMEOUT = 300000;

/** In some situations, we mark the local cache to be cleaned after page reload with this flag. */
export const SCHEDULED_CLEANUP_KEY = `${APP_NAME} cache cleanup`;

/** User cookie helps identifying the current shopping session. */
export const USER_COOKIE_NAME = 'ShoppingKey';
